module.exports = __webpack_public_path__ + "img/platforms.bbf5b65f.png";